import "./Footer.css";

const Footer = () => {
    return (
        <p className="footer">Made for Earthify Hacks 2.0, 10/1/2022. Not affiliated with any organization featured on this page.</p>
    )
}

export default Footer;
